import { Button, FormGroup, InputGroup, Intent } from '@blueprintjs/core'
import { lang } from 'enablex/shared'
import React, { FC, useState, useEffect } from 'react'
import api from '~/app/api'

interface Props {
  onLogin: (email, password) => void
}

const root = document.documentElement

export const LoginForm: FC<Props> = props => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const onSubmit = e => {
    e.preventDefault()
    props.onLogin(email, password)
  }

  const setPageBranding = (branding) => {
    window.document.title = branding.pageTitle || 'EnableX Dialogs'
    window.APP_NAME = branding.pageTitle || 'EnableX Dialogs'

    if (branding.faviconURL) {
      const faviconPath = `/api/v1/bots/___/media/${branding.workspaceId}/${branding.faviconURL}`
      const link = document.querySelector('link[rel="icon"]')
      link && link.setAttribute('href', faviconPath)
      window.APP_FAVICON = faviconPath
    }
  }

  useEffect(() => {
    window.addEventListener('message', function (e) {
      if (!e || !e.data) {
        return
      }
      if (typeof e.data === 'object') {
        return
      }
      try {
        const data_decoded = JSON.parse(e.data)
        if(data_decoded.action === 'portalautologin') {
          const token = data_decoded.data
          const token_value = { token: token.jwt, expiresAt: Date.now() + token.exp, issuedAt: Date.now() }
          localStorage.setItem('enx/token', JSON.stringify(token_value))
          localStorage.setItem('enx/workspace', token.workspace)
          const axios = api.getSecured({ autoLogin: true })
          let themeColor = '#1d6c90'
          const workspaceId = token.workspace
          axios.get(`/admin/user/workspaces/${workspaceId}`).then(response => {
            const { branding } = response.data
            if(branding) {
              localStorage.setItem('enx/branding', JSON.stringify(branding))
              setPageBranding({ ...branding, workspaceId })
              themeColor = branding.themeColor
            } else {
              localStorage.removeItem('enx/branding')
            }
            root.style.setProperty('--theme-color', themeColor)
          }).catch(err => {
            console.error(err)
            localStorage.removeItem('enx/branding')
            root.style.setProperty('--theme-color', themeColor)
          })
        }
      } catch (error) {
        // Handle the error
      }
    })
    return () => {
      // Clean up the event listener when the component unmounts
    }
  },[])

  return (
    <form onSubmit={onSubmit}>
      <FormGroup label={'Username'}>
        <InputGroup
          tabIndex={1}
          value={email}
          onChange={e => setEmail(e.target.value)}
          type="text"
          id="email-login"
          autoFocus={true}
        />
      </FormGroup>

      <FormGroup label={lang.tr('admin.password')}>
        <InputGroup
          tabIndex={2}
          value={password}
          onChange={e => setPassword(e.target.value)}
          type="password"
          id="password-login"
        />
      </FormGroup>

      <Button
        tabIndex={3}
        type="submit"
        id="btn-signin"
        text={lang.tr('admin.signIn')}
        disabled={!email || !password}
        intent={Intent.PRIMARY}
      />
    </form>
  )
}
